import { WORKFLOW_PATH } from '../url';
import ErrorSwitchCase from './ErrorHandlerService';
import HttpService from './HttpService';
const _axios = HttpService.getAxiosClient();

const buildInboxQuery = (filterState, pageSize, pageNo, requestCategory) => {
  const parts = [];
  if (filterState?.monthRange) {
    parts.push(`monthRange=${filterState.monthRange}`);
  }
  if (filterState?.rangeType) {
    parts.push(`rangeType=${filterState.rangeType}`);
  }
  if (filterState?.status) {
    parts.push(`status=${filterState.status}`);
  }
  if (filterState?.employeeId) {
    parts.push(`applierId=${filterState.employeeId}`);
  }
  if (filterState?.projectId) {
    parts.push(`projectId=${filterState.projectId}`);
  }
  if (filterState?.applicationId) {
    parts.push(`applicationId=${filterState.applicationId}`);
  }
  if (filterState?.isUpdatedByAdmin) {
    parts.push(`isUpdatedByHr=${filterState.isUpdatedByAdmin}`);
  }
  if (requestCategory) {
    parts.push(`requestCategory=${requestCategory}`);
  }
  if (pageSize) {
    parts.push(`pageSize=${pageSize}`);
  }
  if (pageNo !== undefined && pageNo >= 0) {
    parts.push(`pageNumber=${pageNo}`);
  }
  return parts.length ? `?${parts.join('&')}` : '';
};

export const ApplyExternalHrs = async (payload) => {
  try {
    const response = await _axios.post(
      `${WORKFLOW_PATH}/external-hours/saveProcess`,
      payload,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const updateApplicationByUser = async (payload) => {
  try {
    const response = await _axios.post(
      `${WORKFLOW_PATH}/external-hours/saveProcess`,
      payload,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const GetExternalHrsRequestsForEmployee = async (
  employeeId,
  filterState,
  pageSize,
  pageNo,
  requestCategory,
) => {
  try {
    const response = await _axios.get(
      `${WORKFLOW_PATH}/external-hours/${employeeId}/external-hours-application${buildInboxQuery(
        filterState,
        pageSize,
        pageNo,
        requestCategory,
      )}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const GetExternalHrsRequestsForFinance = async (
  employeeId,
  filterState,
  pageSize,
  pageNo,
  requestCategory,
) => {
  try {
    const response = await _axios.get(
      `${WORKFLOW_PATH}/external-hours/${employeeId}/external-hours-application/finance${buildInboxQuery(
        filterState,
        pageSize,
        pageNo,
        requestCategory,
      )}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const GetExternalHrsRequestsForSeniorManager = async (
  employeeId,
  filterState,
  pageSize,
  pageNo,
) => {
  try {
    const response = await _axios.get(
      `${WORKFLOW_PATH}/external-hours/${employeeId}/external-hours-application/senior-manager${buildInboxQuery(
        filterState,
        pageSize,
        pageNo,
      )}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

/** @deprecated Legacy manager inbox — backend rejects manager approval mutations. */
export const GetExternalHrsRequestsForManager = async (
  employeeId,
  filterState,
  pageSize,
  pageNo,
  requestCategory,
) => {
  try {
    const response = await _axios.get(
      `${WORKFLOW_PATH}/external-hours/${employeeId}/external-hours-application/manager${buildInboxQuery(
        filterState,
        pageSize,
        pageNo,
        requestCategory,
      )}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

/** @deprecated Legacy HR inbox — backend rejects HR approval mutations. */
export const GetExternalHrsRequestsForHr = async (
  employeeId,
  filterState,
  pageSize,
  pageNo,
  requestCategory,
) => {
  try {
    const response = await _axios.get(
      `${WORKFLOW_PATH}/external-hours/${employeeId}/external-hours-application/hr${buildInboxQuery(
        filterState,
        pageSize,
        pageNo,
        requestCategory,
      )}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const UpdateExternalHrsRequestByFinance = async (payload) => {
  try {
    const response = await _axios.put(
      `${WORKFLOW_PATH}/external-hours/saveProcess/finance/${payload.id}`,
      payload,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const UpdateExternalHrsRequestBySeniorManager = async (payload) => {
  try {
    const response = await _axios.put(
      `${WORKFLOW_PATH}/external-hours/saveProcess/senior-manager/${payload.id}`,
      payload,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

/** @deprecated Use UpdateExternalHrsRequestByFinance / SeniorManager. */
export const UpdateExternalHrsRequestByManager = async (payload) => {
  try {
    const response = await _axios.put(
      `${WORKFLOW_PATH}/external-hours/updateProcess/manager`,
      payload,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

/** @deprecated Use UpdateExternalHrsRequestByFinance. */
export const UpdateExternalHrsRequestByHr = async (payload) => {
  try {
    const response = await _axios.put(
      `${WORKFLOW_PATH}/external-hours/saveProcess/hr/${payload.id}`,
      payload,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};
